import React, { CSSProperties } from 'react'
import cn from 'classnames'
import { Button } from '@corratech/pylot-ui'
import s from './OptionColorTiles.module.scss'
import type { OptionColorTileOption } from './OptionColorTiles'

export interface VisualSwatchProps {
    option: OptionColorTileOption
    styles?: CSSProperties
    disabled?: boolean
    className?: string
}

const isImageSwatch = (swatchData: OptionColorTileOption['swatch_data']) =>
    swatchData?.__typename === 'ImageSwatchData' ||
    swatchData?.type === 'ImageSwatchData'

export const VisualSwatch = ({
    option,
    styles,
    disabled,
    className
}: VisualSwatchProps) => {
    const swatchData = option.swatch_data
    const bgType: CSSProperties = isImageSwatch(swatchData)
        ? {
              backgroundImage: `url(${swatchData?.thumbnail ?? ''})`
          }
        : {
              backgroundColor: swatchData?.value ?? undefined
          }

    return (
        <Button
            style={{ ...bgType, ...styles }}
            disabled={disabled}
            variant="link"
            title={option.label ?? ''}
            className={cn(s['visual-swatch'], className)}
        />
    )
}
